import { CheckIcon, MinusIcon } from "@radix-ui/react-icons";
import React from "react";

export default function PasswordTooltip({
  value,
  isModal = false,
}: {
  value: string;
  isModal?: boolean;
}) {
  const getPasswordRequirements = () => {
    const hasLetter = /[a-zA-Z]/.test(value);
    const hasNumber = /\d/.test(value);
    const hasMinLength = value.length >= 8;

    const requirements = [
      { text: "1 letter", met: hasLetter },
      { text: "1 number", met: hasNumber },
      { text: "8 characters", met: hasMinLength },
    ];
    return requirements;
  };

  // Determine positioning based on mobile/desktop and modal context
  const getPositioningClasses = () => {
    if (isModal) {
      return "bottom-full left-0 mb-2";
    } else {
      return "top-full md:top-[-25px] left-0 mt-2 md:right-full md:left-auto md:mb-0 md:mr-3";
    }
  };

  const getArrowClasses = () => {
    if (isModal) {
      return "top-full left-4";
    } else {
      return "top-[40px] -right-[8px]";
    }
  };

  const getArrowInnerClasses = () => {
    if (isModal) {
      return "top-full left-4";
    } else {
      return "top-[41px] -right-[7px]";
    }
  };

  return (
    <div
      role="tooltip"
      className={`absolute ${getPositioningClasses()} z-20 w-full ${isModal ? "max-w-[200px]" : "md:max-w-[128px]"} drop-shadow-[0_0.125rem_0.25rem_rgba(0,0,0,0.15)] opacity-100`}
    >
      <div className="bg-white border border-gray-200 p-3 rounded relative">
        {/* Arrow */}
        <div
          className={`hidden md:block absolute ${getArrowClasses()} w-0 h-0 ${
            isModal
              ? "border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-t-[6px] border-t-gray-300"
              : "border-l-[8px] border-l-gray-300 border-t-[8px] border-t-transparent border-b-[8px] border-b-transparent"
          }`}
        ></div>
        <div
          className={`hidden md:block absolute ${getArrowInnerClasses()} w-0 h-0 ${
            isModal
              ? "border-l-[5px] border-l-transparent border-r-[5px] border-r-transparent border-t-[5px] border-t-white"
              : "border-l-[7px] border-l-white border-t-[7px] border-t-transparent border-b-[7px] border-b-transparent"
          }`}
          style={isModal ? { top: "calc(100% - 1px)" } : {}}
        ></div>

        {getPasswordRequirements().map((req, index) => (
          <span key={index} className="flex items-center text-xs text-gray-500">
            <span className="block mr-1 w-6 h-6">
              {req.met ? (
                <CheckIcon
                  width={24}
                  height={24}
                  className="text-success-500"
                />
              ) : (
                <MinusIcon width={24} height={24} className="text-[#d7d3d1]" />
              )}
            </span>
            {req.text}
          </span>
        ))}
      </div>
    </div>
  );
}
